import { WithTitle } from "../shared";

import CustomPieChart from "@/components/reusables/charts/CustomPieChart";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";

// export const colors = ["#03045E", "#ECFCFF", "#FF9A9A", "#3354F4", "#023E8A"];
export const colors = [
  "#03045E",
  "#FFCE56",
  "#FF9F40",
  "#4BC0C0",
  "#36A2EB",
  "#FF6384",
  "#ECFCFF",
  "#9966FF",
];

type TProps = {
  name: string;

  colorCode: string;
  progressValue: number;
};

const CompositionType: React.FC<TProps> = ({
  name,

  colorCode,
  progressValue,
}) => {
  return (
    <div className='grid grid-cols-[100px_2fr] gap-1 items-center'>
      <div className='grid md:grid-cols-[20px_1fr] items-center '>
        <div
          className='size-2 aspect-square shrink-0'
          style={{
            backgroundColor: colorCode,
          }}
        />
        <p className='text-sm truncate'>{name}</p>
      </div>
      <div className='relative min-w-0 text-xs'>
        <p className='truncate text-right absolute right-0 top-[-16px]'>
          {progressValue ? progressValue.toFixed(2) : 0}%
        </p>
        <Progress
          segments={[
            {
              value: progressValue || 0,
              color: colorCode ?? "#2843BC",
            },
          ]}
          className='bg-gray-200 min-w-[100px] h-2'
        />
        {/* <p className='text-right truncate'>{value}</p> */}
      </div>
    </div>
  );
};

type TMaterialCompositionProps = { composition: object; className?: string };

const MaterialComposition: React.FC<TMaterialCompositionProps> = ({
  composition,
  className,
}) => {
  const finalData = Array.from(Object.entries(composition)).map(
    (data, dataIdx) => ({
      name: data[0] || "",
      value: Math.abs(data[1]) || 0,
      fill: colors[dataIdx % colors.length],
    }),
  );

  const emptyData = {
    name: "No Data",
    value: 100,
    fill: colors[0],
  };

  const totalValue = finalData?.reduce((a, c) => +a + +c?.value, 0);

  const finalChartData = finalData?.length ? finalData : [emptyData];

  return (
    <>
      <WithTitle
        title='Material Composition'
        className='max-w-full min-w-0 p-4'
      >
        <div className={cn("grid grid-cols-1 xl:grid-cols-2", className)}>
          <CustomPieChart
            pieChartDatas={finalChartData}
            dataKey='value'
            pieChartColors={colors}
          />
          <div className='space-y-4'>
            {finalChartData?.map((data) => (
              <CompositionType
                key={`${data?.name}-${data?.value}`}
                name={data?.name}
                colorCode={data?.fill}
                // value={data?.value}
                progressValue={(+data?.value / totalValue) * 100}
              />
            ))}
          </div>
        </div>
      </WithTitle>
    </>
  );
};

export default MaterialComposition;
